import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import { Button, Form, Grid, Header, Segment, Message } from 'semantic-ui-react';
import UserApi from './utils/UserApi'
import Storage from './utils/Storage'

class Login extends Component {
  constructor(props){
    super(props)
    this.default = {
      password: "",
      email: "",
      name: "",
      redirect: null,
      error: false,
      e_msg: "",
      register: false,
      unconfirmed:false
    }
    this.state = this.default

    this.handleChange = this.handleChange.bind(this)
    this.handleButton1 = this.handleButton1.bind(this)
    this.handleButton2 = this.handleButton2.bind(this)
  }

  handleChange(event, {name, value}){
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  }

  handleLogin(){
    UserApi.login(this.state)
    .then(response => {
      if(response.data.success){
        Storage.saveToken(response.data.access_token)
        if(response.data.admin){
          Storage.setAsAdmin()
        }
        console.log(response)
        this.setState({
          redirect:"/dashboard"
        })
      } else {
        this.setState({
          error:true,
          e_msg: response.data.message,
          unconfirmed: false
        })
      }
    })
  }

  handleButton1(){
    if(!this.state.register){
      this.handleLogin()
    } 
    else {
      this.setState(this.default)
    }
  }

  handleButton2(){
    if(!this.state.register){
      this.setState({
        register: true,
        error: false,
        unconfirmed: false
      });
    }
    else {
      UserApi.newUser(this.state)
      .then(response => {
        console.log(response)
        if(response.data.success){
          this.setState({
            unconfirmed:true,
            register:false
          })
        } else {
          this.setState({
            error: true,
            e_msg: response.data.message
          })
        }
      })
    }
  }
  render() {

    if(Storage.isLoggedIn()){
      console.log("BuhHHhh")
      return <Redirect to={"/dashboard"} />
    }
    if(this.state.redirect !== null){
      return <Redirect to={this.state.redirect} />
    }
    return (

      <div style={{height: '100%'}}>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as='h1' color='purple' textAlign='center'>
              HACKMIT
            </Header>
            <Header as='h3' color='purple' textAlign='center'>
              MJAPPREADER
            </Header>
            <Form size='large' >
              <Segment stacked style={{backgroundColor: 'darkgrey'}}>
                {this.state.register && 
                  <Message positive>
                    <Message.Header>Register New User</Message.Header>
                  </Message>
                }
                {this.state.unconfirmed && 
                  <Message info>
                    <Message.Header>New User Created! </Message.Header>
                    <p>Please wait for admin confirmation</p>
                  </Message>
                }
                {this.state.register && 
                  <Form.Input 
                  fluid 
                  placeholder='Name'
                  value={this.state.name}
                  name="name"
                  onChange={this.handleChange}
                  /> 
                }
                <Form.Input 
                  fluid 
                  placeholder='Username'
                  value={this.state.email}
                  name="email"
                  onChange={this.handleChange}
                  /> 
                <Form.Input
                  fluid
                  placeholder='Password'
                  type='password'
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
                {this.state.error &&
                  <Message negative>
                    <Message.Header>Authentication failed</Message.Header>
                    <p>{this.state.e_msg}</p>
                  </Message>
                }
                <Button color='purple' fluid size='large' onClick={this.handleButton1}>
                  {this.state.register ? <p>Cancel</p> : <p>Login</p>}
                </Button>
                <br />
                <Button color='teal' fluid size='large' onClick={this.handleButton2}>
                  Register
                </Button>
        
              </Segment>
            </Form>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
};

// mapStateToProps to connect Login page with redux
// const mapStatetoProps = state => {
//   console.log(state);
// };

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js